import type { Notification } from '../services/api/notificationService';

export function filterCustomerNotifications(
  notifications: Notification[],
  filter: 'all' | 'unread' | 'read',
  categoryFilter: string,
  searchTerm: string
): Notification[] {
  const q = searchTerm.trim().toLowerCase();
  return notifications.filter((notification) => {
    const matchesFilter =
      filter === 'all' ||
      (filter === 'unread' && !notification.isRead) ||
      (filter === 'read' && notification.isRead);

    const matchesCategory =
      categoryFilter === 'all' || notification.type === categoryFilter;

    const title = (notification.title ?? '').toLowerCase();
    const message = (notification.message ?? '').toLowerCase();
    const matchesSearch = q === '' || title.includes(q) || message.includes(q);

    return matchesFilter && matchesCategory && matchesSearch;
  });
}

export function groupCustomerNotificationsByDate(
  notifications: Notification[]
): { label: string; notifications: Notification[] }[] {
  const groups: { label: string; notifications: Notification[] }[] = [];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const weekAgo = new Date(today);
  weekAgo.setDate(weekAgo.getDate() - 7);

  const todayNotifications: Notification[] = [];
  const yesterdayNotifications: Notification[] = [];
  const weekNotifications: Notification[] = [];
  const olderNotifications: Notification[] = [];

  notifications.forEach((notification) => {
    const notifDate = new Date(notification.createdAt);
    notifDate.setHours(0, 0, 0, 0);

    if (notifDate.getTime() === today.getTime()) {
      todayNotifications.push(notification);
    } else if (notifDate.getTime() === yesterday.getTime()) {
      yesterdayNotifications.push(notification);
    } else if (notifDate >= weekAgo) {
      weekNotifications.push(notification);
    } else {
      olderNotifications.push(notification);
    }
  });

  if (todayNotifications.length > 0) {
    groups.push({ label: '今天', notifications: todayNotifications });
  }
  if (yesterdayNotifications.length > 0) {
    groups.push({ label: '昨天', notifications: yesterdayNotifications });
  }
  if (weekNotifications.length > 0) {
    groups.push({ label: '本周', notifications: weekNotifications });
  }
  if (olderNotifications.length > 0) {
    groups.push({ label: '更早', notifications: olderNotifications });
  }

  return groups;
}

export function getCustomerNotificationTypeLabel(type: string): string {
  switch (type) {
    case 'message':
    case 'message_new':
      return '消息';
    case 'job_status':
    case 'job_new':
      return '服務狀態';
    case 'new_recommended_case':
      return '推薦案件';
    case 'payment':
    case 'payment_received':
    case 'payment_pending':
      return '付款';
    case 'review_new':
    case 'review_reply':
      return '評價';
    case 'system':
      return '系統';
    default:
      return '其他';
  }
}

export function getCustomerNotificationIconBg(type: string): string {
  switch (type) {
    case 'message':
    case 'message_new':
      return 'bg-blue-500';
    case 'job_status':
    case 'job_new':
    case 'new_recommended_case':
      return 'bg-green-500';
    case 'payment':
    case 'payment_received':
    case 'payment_pending':
      return 'bg-purple-500';
    case 'review_new':
    case 'review_reply':
      return 'bg-amber-500';
    case 'system':
      return 'bg-yellow-500';
    default:
      return 'bg-gray-500';
  }
}
